import { reject } from 'ramda';
import { apolloClient } from '@/apollo';
import * as types from '../mutation-types';
import {
  CreateReportDocument,
  DeleteReportDocument,
  UpdateReportDocument,
  RestoreReportDocument,
  DuplicateReportDocument,
} from '@/graphql/operations.gen';
import updateProjectCache from '@utils/updateProjectCache';

// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  create({ commit }, { projectId, type, name, comment, settings }) {
    commit(types.REPORT_CREATE, {
      meta: {
        analytics: [['event', 'report', 'create']],
      },
    });

    return apolloClient
      .mutate({
        mutation: CreateReportDocument,
        variables: {
          projectId,
          type,
          name,
          comment,
          settings,
        },
        update(store, response) {
          updateProjectCache(store, projectId, (project) => ({
            reports: [...project.reports, response.data.createReport],
          }));

          return response;
        },
      })
      .then((data) => data.data.createReport);
  },

  delete(_context, { id, projectId }) {
    return apolloClient
      .mutate({
        mutation: DeleteReportDocument,
        variables: {
          id,
        },
        update(store, response) {
          updateProjectCache(store, projectId, (project) => ({
            reports: reject((report) => report.id === id, project.reports),
          }));

          return response;
        },
      })
      .then((data) => data.data.deleteReport);
  },

  restore(_context, { id, projectId }) {
    return apolloClient
      .mutate({
        mutation: RestoreReportDocument,
        variables: {
          id,
        },
        update(store, response) {
          updateProjectCache(store, projectId, (project) => ({
            reports: [...project.reports, response.data.restoreReport],
          }));

          return response;
        },
      })
      .then((data) => data.data.restoreReport);
  },

  update(_context, { report, data }) {
    return apolloClient.mutate({
      mutation: UpdateReportDocument,
      variables: {
        ...data,
      },
      optimisticResponse: {
        __typename: 'Mutation',
        updateReport: {
          ...report,
          ...data,
          __typename: 'Report',
        },
      },
    });
  },

  /**
   * Duplicate report.
   *
   * @param {*} context
   * @param {*} payload
   */
  duplicate({ commit }, { id, projectId }) {
    commit(types.REPORT_DUPLICATE, {
      meta: {
        analytics: [['event', 'report', 'duplicate']],
      },
    });

    return apolloClient
      .mutate({
        mutation: DuplicateReportDocument,
        variables: {
          id,
        },
        update(store, response) {
          updateProjectCache(store, projectId, (project) => ({
            reports: [...project.reports, response.data.duplicateReport],
          }));

          return response;
        },
      })
      .then((data) => data.data.duplicateReport);
  },
};

const mutations = {
  [types.REPORT_CREATE]() {},

  [types.REPORT_DUPLICATE]() {},
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
